import client from '../config/AxiosConfig'

export const GetSKUConsumption = async (data = {}) =>
  client.post('/Forecast/GetSKUConsumption', data)

export const GetSKUConsumptionDetails = async data =>
  client.post('/Forecast/GetSKUConsumptionDetails', data)
